import React, { Component } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { NavLink } from "react-router-dom";

import { artImg, bussImg, engImg, lawImg, lifeScinceImg } from "../static";

class FacultyList extends Component {
  state = {
    responsive: {
      0: {
        items: 1,
      },
      450: {
        items: 2,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  };
  render() {
    return (
      <section id="faculty">
        <div className="title">
          <p className="heading3">Faculties</p>
        </div>
        <div className="faculty">
          <OwlCarousel
            className="owl-theme"
            loop
            margin={10}
            items={4}
            autoPlay={true}
            responsive={this.state.responsive}
          >
            <div class="item" className="item">
              {/* <!--        single department start--> */}
              <div className="card">
                <NavLink exact to="/facultyOfArts">
                  {" "}
                  <img
                    src={artImg}
                    className="figure-img img-fluid rounded eventImage"
                    alt="Arts"
                  />
                </NavLink>
                <div className="card-body">
                  <NavLink exact to="/facultyOfArts">
                    <div className="text-center facultyName">
                      Faculty of Arts
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
            {/* <!--        single department end -->
                    <!--        single department start--> */}
            <div class="item" className="item">
              <div className="card">
                <NavLink exact to="/facultyOfBusinessAdministration">
                  {" "}
                  <img
                    src={bussImg}
                    className="figure-img img-fluid rounded eventImage"
                    alt="Business"
                  />{" "}
                </NavLink>
                <div className="card-body">
                  <NavLink exact to="/facultyOfBusinessAdministration">
                    <div className="text-center facultyName">
                      Faculty of Business Administration
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
            {/* <!--        single department end -->
                    <!-- single department start--> */}
            <div class="item" className="item">
              <div className="card">
                <NavLink exact to="/facultyOfEngineering">
                  {" "}
                  <img
                    src={engImg}
                    className="figure-img img-fluid rounded eventImage"
                    alt="Engineering"
                  />
                </NavLink>
                <div className="card-body">
                  <NavLink exact to="/facultyOfEngineering">
                    <div className="text-center facultyName">
                      Faculty of Engineering and Technology
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
            {/* <!--        single department end -->
                    <!--        single department start--> */}
            <div class="item" className="item">
              <div className="card">
                <NavLink exact to="/facultyOfLaw">
                  {" "}
                  <img
                    src={lawImg}
                    className="figure-img img-fluid rounded eventImage"
                    alt="Law"
                  />
                </NavLink>
                <div className="card-body">
                  <NavLink exact to="/facultyOfLaw">
                    <div className="text-center facultyName">
                      Faculty of Law
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
            {/* <!--        single department end --> */}
            <div class="item" className="item">
              <div className="card">
                <NavLink exact to="/facultyOfLifeScience">
                  <img
                    src={lifeScinceImg}
                    className="figure-img img-fluid rounded eventImage"
                    alt="Faculty of Life Science"
                  />
                </NavLink>
                <div className="card-body">
                  <NavLink exact to="/facultyOfLifeScience">
                    <div className="text-center facultyName">
                      Faculty of Life Science
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </OwlCarousel>
        </div>
      </section>
    );
  }
}

export default FacultyList;
